import {useMemo} from 'react';
import {twMerge} from '../../../common/twMerge';
import {DISPLAY_AD_HEIGHT} from '../../../domain/content/[seriesId]/viewer/[productId]/constant/talkViewerConstant';
import {ZIndex} from '../../../domain/content/[seriesId]/viewer/[productId]/type/ZIndex.enum';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {TalkKatalkSceneHeaderProps} from './TalkKatalkSceneHeaderProps.interface';

export function TalkKatalkSceneHeader({
  title,
  isViewerMenuExposed,
  isExposeDaInTalkViewer,
  viewerMenuHeight,
  isKatalkScene,
}: TalkKatalkSceneHeaderProps) {
  // 카톡씬 헤더 top 영역을 구하는 로직
  const katalkHeaderTop = useMemo(() => {
    // 기본 top높이. 카톡더보기에서는 상단 GNB영역이 존재하기 때문에 해당 높이만큼 기본으로 띄어준다.
    // const baseTop = isKatalk ? MOBILE_HEADER_HEIGHT : 0;
    const baseTop = 0;
    // DA미노출 상태에서는 뷰어 맨 위에 붙으면 되므로 기본 baseTop만큼만 띄운다.
    if (!isExposeDaInTalkViewer) {
      return baseTop;
    }
    // DA노출상태에서 뷰어메뉴가 열려있으면, 어차피 DA가 숨겨지므로 뷰어메뉴 아래에 카톡 헤더가 붙어서 보이도록 한다.
    if (isViewerMenuExposed) {
      return viewerMenuHeight.top + baseTop;
    }
    // DA노출 상태에서 뷰어메뉴가 없으면 DA가 가려지지 않도록 DA영역만큼 더 띄어준다.
    else {
      return DISPLAY_AD_HEIGHT + baseTop;
    }
  }, [isExposeDaInTalkViewer, isViewerMenuExposed, viewerMenuHeight.top]);
  return (
    <div
      className={twMerge(
        // TODO: @Root-huh bg-[#abc1d1] - 매칭되는 디자인 토큰 없음
        'fixed box-content flex h-96tvs w-full items-center bg-[#abc1d1] opacity-90 transition-opacity duration-[1.5s]',
        !isKatalkScene && 'pointer-events-none opacity-0'
      )}
      style={{
        // 노치 영역
        paddingTop: `${
          isViewerMenuExposed ? 0 : viewerMenuHeight.safeAreaTop || 0
        }px`,
        top: `${katalkHeaderTop}px`,
        zIndex: ZIndex.Talk + 1,
        borderBottom: '1px solid rgba(0, 0, 0.08)',
      }}
    >
      <Text className="flex-1 pt-4tvs pl-40tvs text-34tvs text-static-mono-black">
        {title}
      </Text>
      <Icon type={IconType.BtnKatalkMenu} className="mr-18tvs w-64tvs" />
      <Icon type={IconType.BtnKatalkSearch} className="mr-12tvs w-64tvs" />
    </div>
  );
}
